import { connect } from 'react-redux';
import { getCurrentBranding } from '../../../redux/reducers/branding.reducer';
import LazyLoadCustom from '../LazyLoadCustom/LazyLoadCustom';
import { NotificationsNoneOutlined } from '@mui/icons-material';
import { Avatar, IconButton } from '@material-ui/core';
import { getUserProfile } from '../../../redux/reducers/userProfile.reducer';
import { useEffect, useState } from 'react';
import { get, getAvatarForUser } from '../../../Utilities';
import { getClientUserId } from '../../../redux/reducers/clientUserId.reducer';
import InitialsAvatar from '../../Login/Preloader/InitialsAvatar';

function moveLastTwoToFront(str) {
  if (str.length <= 2) return str; // Nothing to move
  return str.slice(-2) + ' ' + str.slice(0, -2);
}

const PageHeaderNew = (props) => {
  const {
    branding,
    history,
    userProfile,
    //goToProfile,
    // goToNotifications,
    // badgeValue,
    isClientColor,
    clientUserId,
    // greeting,
  } = props;

  const [greeting, setTime] = useState('');
  const [badgeValue, setBadgeValue] = useState('');

  const goToProfile = () => {
    const { push } = history;

    push({ pathname: '/profile' });
  };

  const goToNotifications = () => {
    const { push } = history;

    push('/notifications');
  };

  const partsOfDay = () => {
    const hours = new Date().getHours();

    if (hours >= 0 && hours < 12) setTime('Good Morning 🌤');
    else if (hours >= 12 && hours <= 17) setTime('Good Afternoon ☀️');
    else if (hours >= 17 && hours < 21) setTime('Good Evening 🌜');
    else if (hours >= 21 && hours < 24) setTime('Good Evening 🌜');
  };

  useEffect(() => {
    partsOfDay();
    get({ client_user_id: clientUserId }, '/ckeckNewNotifications').then((res) => {
      if (res && res.success) {
        setBadgeValue(res.result);
      }
    });
  }, []);

  return (
    <div
      style={
        isClientColor ? { backgroundColor: 'var(--primary-blue)' } : { backgroundColor: 'white' }
      }
      className=' PageHeader__headerNew'
    >
      <div className='pr-3 pl-2 py-1 d-flex align-items-center PageHeader__headerNewContainer justify-content-between'>
        <div className='d-flex align-items-center'>
          <LazyLoadCustom
            className='PageHeader__clientLogo'
            src={branding?.branding?.client_logo}
          />
          <p className='mb-0 ml-3 PageHeader__greeting font'>{greeting}</p>
          <p className='mb-0 ml-3 PageHeader__clientName font'>{branding?.branding?.client_name}</p>
        </div>
        <div className='d-flex align-items-center position-relative'>
          <p className='PageHeader__nameGreetingText font'>
            {moveLastTwoToFront(greeting)}, {userProfile?.firstName}
          </p>
          <IconButton onClick={goToNotifications} className='mx-1 position-relative'>
            <NotificationsNoneOutlined />
            {badgeValue ? <div className='PageHeader__notiiconBadge'>{badgeValue}</div> : null}
          </IconButton>
          {!userProfile.profile_image ? (
            <InitialsAvatar
              onClick={goToProfile}
              role='button'
              name={`${userProfile.firstName} ${userProfile.lastName}`}
              color={getAvatarForUser(clientUserId)}
              size='sm'
            />
          ) : (
            <Avatar
              onClick={goToProfile}
              style={{ width: '30px', height: '30px', cursor: 'pointer' }}
              alt={`${userProfile.first_name} ${userProfile.last_name}`}
              src={userProfile.profile_image}
              sx={{ bgcolor: 'red' }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  branding: getCurrentBranding(state),
  userProfile: getUserProfile(state),
  clientUserId: getClientUserId(state),
});

export default connect(mapStateToProps, null)(PageHeaderNew);
